// Playful sparkle trail (desktop cursor) + add-to-cart celebration
// (sparkles + cart icon bounce, works on touch too). Respects
// prefers-reduced-motion throughout; the cursor trail additionally only
// runs on fine-pointer (mouse) devices since it makes no sense on touch.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (prefersReducedMotion) return;

  var SPARKLES = ['✨', '💫', '⭐', '🎀'];
  var MAX_ON_SCREEN = 30;
  var MIN_INTERVAL_MS = 70;

  var activeCount = 0;
  var lastSpawn = 0;

  function spawnSparkle(x, y) {
    if (activeCount >= MAX_ON_SCREEN) return;

    var el = document.createElement('span');
    el.className = 'squishy-sparkle';
    el.textContent = SPARKLES[Math.floor(Math.random() * SPARKLES.length)];
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    el.style.setProperty('--drift', (Math.random() * 40 - 20).toFixed(0) + 'px');

    document.body.appendChild(el);
    activeCount++;

    var cleanup = function () {
      el.removeEventListener('animationend', cleanup);
      el.remove();
      activeCount--;
    };
    el.addEventListener('animationend', cleanup);
    // Safety net in case animationend never fires (e.g. tab backgrounded)
    setTimeout(cleanup, 1200);
  }

  // Cursor sparkle trail — desktop mouse only, doesn't make sense on touch.
  if (hasFinePointer) {
    document.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType !== 'mouse') return;
        var now = performance.now();
        if (now - lastSpawn < MIN_INTERVAL_MS) return;
        lastSpawn = now;
        spawnSparkle(event.clientX, event.clientY);
      },
      { passive: true }
    );
  }

  // Extra sparkle burst around a button when an item is successfully added to cart
  function burstAround(el) {
    var rect = el.getBoundingClientRect();
    for (var i = 0; i < 8; i++) {
      var x = rect.left + Math.random() * rect.width;
      var y = rect.top + Math.random() * rect.height;
      spawnSparkle(x, y);
    }
  }

  // Bounce the header cart icon so the "your item landed in the cart" feeling
  // is visible even for people who add from far down the page.
  function bounceCartIcon() {
    var cartIcon = document.querySelector('cart-icon');
    if (!cartIcon) return;
    cartIcon.classList.remove('squishy-cart-bounce');
    void cartIcon.offsetWidth;
    cartIcon.classList.add('squishy-cart-bounce');
  }

  var addedObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var el = mutation.target;
      if (el.getAttribute && el.getAttribute('data-added') === 'true') {
        burstAround(el);
        bounceCartIcon();
      }
    });
  });

  function observeAddButtons() {
    document.querySelectorAll('[name="add"]').forEach(function (btn) {
      addedObserver.observe(btn, { attributes: true, attributeFilter: ['data-added'] });
    });
  }

  observeAddButtons();

  // Quick-add buttons can be added to the DOM later (e.g. the "load more"
  // product grid). Rather than an expensive whole-page MutationObserver,
  // scripts that inject new add-to-cart buttons dispatch this event.
  document.addEventListener('squishy:grid-updated', observeAddButtons);
})();
